import { ReactNode, useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { SupervisorContext } from '../contexts/SupervisorContext';
import SelectClientPage from '../pages/Supervise/SelectClientPage';

type AuthGuardProps = {
  children?: ReactNode;
};

const SuperviseGuard = ({ children }: AuthGuardProps) => {
  const { currentClient, isSupervising } = useContext(SupervisorContext);
  const location = useLocation();

  if (!isSupervising) return <>{children}</>;

  // No client selected → show client selection page
  if (!currentClient) return <SelectClientPage />;

  // Client selected but user is on root → redirect to supervisor hub
  if (location.pathname === '/' || location.pathname === '/login') {
    return <Navigate to="/supervisor" replace />;
  }

  // Client selected and navigating to a valid sub-route → render normally
  return <>{children}</>;
};

export default SuperviseGuard;
